import { useEffect } from 'react';

interface UseTrackOpenHook<T> {
  open: boolean | undefined;
  onOpen?: (e?: T) => void;
  props?: T;
}

const useTrackOpenHook = <T>({ open, onOpen, props }: UseTrackOpenHook<T>) => {
  useEffect(() => {
    if (!open || typeof onOpen !== 'function') {
      return;
    }

    onOpen(props);
  }, [open]);
  return true;
};

export default useTrackOpenHook;
